<template>
    <div class="notification-sending">
        <button
            v-if="isAccessBtnSendingEmails"
            @click="openPopup"
            class="notification-sending__sending-button"
            :disabled="!count"
            v-loading.small.dark="loading"
        >
            Сделать рассылку
        </button>

        <UserSearchNotificationMobileChoose
            v-if="popupState.mobileChoose"
            :loading="loading"
            @close="closePopups"
            @submit="mobileChoose"
        />

        <UserSearchNotificationPush
            v-if="popupState.push"
            :loading="loading"
            @close="closePopups"
            @submit="formSubmitted($event, 'push')"
        />

        <UserSearchNotificationDialogEmailTemplate
            v-if="popupState.template"
            :loading="loading"
            @close="closePopups"
            @template="emailTemplateSelected"
            @submit="formSubmitted"

        />

        <UserSearchNotificationDialogEmailDefault
            v-if="popupState.default"
            :loading="loading"
            @close="closePopups"
            @submit="formSubmitted($event, 'default')"
        />

        <UserSearchNotificationDialogConfirm
            v-if="popupState.confirm"
            :loading="loading"
            :template="formType"
            @close="closePopups"
            :prettieredQuantity="prettieredQuantity"
            :countedQuantityText="countedQuantityText"
            @submit="sendForm"
        />
    </div>
</template>

<script>
import {mapGetters} from "vuex";
import strCounter from "@/tools/str_counter";
import gql from "graphql-tag";
import {get, post} from "@/tools/http";
import UserSearchNotificationDialogConfirm
    from "@/components/user-search/notification/UserSearchNotificationDialogConfirm.vue";
import UserSearchNotificationDialogEmailTemplate
    from "@/components/user-search/notification/UserSearchNotificationDialogEmailTemplate.vue";
import UserSearchNotificationDialogEmailDefault
    from "@/components/user-search/notification/UserSearchNotificationDialogEmailDefault.vue";
import UserSearchNotificationMobileChoose
    from "@/components/user-search/notification/UserSearchNotificationMobileChoose.vue";
import UserSearchNotificationPush from "@/components/user-search/notification/UserSearchNotificationPush.vue";

const ROLE_ACCESS_IN_DENIED = ['ROLE_USER_ADMIN_READ_ONLY_NO_CONTACTS'];


export default {
    name: "UserSearchNotificationSending",

    components: {
        UserSearchNotificationPush,
        UserSearchNotificationMobileChoose,
        UserSearchNotificationDialogEmailDefault,
        UserSearchNotificationDialogEmailTemplate,
        UserSearchNotificationDialogConfirm,
    },

    emits: [
        "submit",
    ],

    props: {
        count: {
            type: Number,
        },
    },

    data: () => ({
        loading: false,

        popupState: {
            mobileChoose: false,
            push: false,
            confirm: false,
            template: false,
            default: false,
        },


        filterQueryToNotify: '',

        formType: null,
        formData: null,
    }),

    computed: {
        ...mapGetters(['getUsersQueryData', 'getUsersQueryFilter', 'userProfileInfo', 'isAuthorized']),

        isAccessBtnSendingEmails() {
            if (this.isAuthorized) {
                const roles = this.userProfileInfo.roles || [];
                return !!ROLE_ACCESS_IN_DENIED.find(v => !roles.includes(v));
            }

            return true;
        },

        prettieredQuantity() {
            return this.count.toString().replace(/(?!^)(?=(?:\d{3})+(?:\.|$))/gm, ' ');
        },

        countedQuantityText() {
            return strCounter('пользовате', 'ль', 'ля', 'лей')(this.count);
        },

        filtersQueryBuild() {
            const queryDataWhere = this.getUsersQueryData;

            return gql`
                query {
                    elasticQueryString(${queryDataWhere})
                    {
                        queryString
                    }
                }
            `;
        },
    },

    methods: {
        emailTemplateSelected(v) {
            if (v === 'default') {
                this.$set(this.popupState, 'template', false);
                this.$set(this.popupState, 'default', true);
            }
        },

        async initElasticQuery() {
            this.loading = true;

            try {
                const apolloClient = this.$apolloProvider.clients.apolloClient;
                const result = await apolloClient.query({ query: this.filtersQueryBuild });

                if (result) {
                    const queryString = JSON.parse(result.data.elasticQueryString.queryString);
                    this.filterQueryToNotify = JSON.stringify(queryString.query);
                }
            } catch (error) {
                console.error('Error during Apollo query:', error);
            }

            this.loading = false;
        },

        async openPopup() {
            await this.initElasticQuery();

            if (this.getUsersQueryFilter.params.profile.withRsvMobileApp) {
                this.$set(this.popupState, 'mobileChoose', true);
            } else {
                this.$set(this.popupState, 'template', true);
            }
        },

        closePopups() {
            for (const k in this.popupState) {
                this.$set(this.popupState, k, false);
            }
            this.formData = null;
            this.formType = null;
        },

        mobileChoose(type) {
            this.closePopups();

            if (type === 'push') {
                this.$set(this.popupState, 'push', true);
            } else {
                this.$set(this.popupState, 'template', true);
            }
        },

        formSubmitted(formData, type) {
            this.closePopups();
            this.formData = formData;
            this.formType = type;
            this.$set(this.popupState, 'confirm', true);
        },

        async sendForm() {
            this.loading = true;

            try {
                if (this.formType === 'ready') {
                    await this.sendReadyTemplate();
                } else if (this.formType === 'push') {
                    await this.sendMobileNotify();
                } else {
                    await this.sendDefaultTemplate();
                }
            } catch (error) {
                console.error('Error during Send form query:', error);
            }

            this.closePopups();
            this.loading = false;
        },

        async sendNotify(body) {
            try {
                await post(
                    'notify',
                    'api/v1/notify/create',
                    body,
                    {},
                    {}
                );
            } catch (e) {
                console.error('Error during notify/create query:', e, body);
            }
        },

        async sendReadyTemplate() {
            await this.sendNotify({
                payload: {
                    template: 'plain',
                    variables: {
                        theme: this.formData.templateTheme,
                        text: this.formData.content,
                    },
                },
                type: 'mail_send_out_from_query',
                trigger_type: 12,
                filter_query: this.filterQueryToNotify,
                meta: {
                    subject: this.formData.templateTheme,
                },
            });
        },
        async sendDefaultTemplate() {
            await this.sendNotify({
                payload: {
                    template: 'default',
                    variables: {
                        theme: this.formData.subject,
                        text: this.formData.htmlText,
                    },
                },
                type: 'mail_send_out_from_query',
                trigger_type: 12,
                filter_query: this.filterQueryToNotify,
                meta: {
                    subject: this.formData.subject,
                },
            });
        },
        async sendMobileNotify() {
            await this.sendNotify({
                payload: {
                    notification: {
                        title: this.formData.title,
                        body: this.formData.text,
                    },
                    data: {
                        click_action: 'FLUTTER_NOTIFICATION_CLICK',
                        category_name: this.formData.title,
                        link_text: this.formData.text,
                        link_url: this.formData.link,
                        text: this.formData.text,
                        type: 'push_send_out_from_query',
                        arguments: JSON.stringify({
                            dl: this.formData.link,
                        }),
                    },
                },
                type: 'push_send_out_from_query',
                trigger_type: 13,
                filter_query: this.filterQueryToNotify,
                meta: {
                    app_name: 'rsv_mobile_app',
                },
            });
        },
    },
};
</script>


<style scoped lang="scss">
@import '~@/styles/rem';
@import '~@/styles/variables';

.notification-sending {

    @include on-desktop {
        margin: 0 auto;
        width: rem(1608);
        border-bottom: urem(2) solid #848196;
    }

    &__sending-button {
        width: 100%;
        padding: urem(14) urem(32);
        margin: urem(24) 0;
        background: $color-main-blue;
        border: none;
        border-radius: urem(10);
        text-align: center;
        color: #ffffff;
        @include set-font-size(14, 600, 20);
        @include on-desktop {
            margin: 0 0 urem(24) 0;
            width: auto;
            cursor: pointer;
        }
    }
}


</style>
